import { Box, Stack, Typography } from '@mui/material'
import { useEffect } from 'react'
import { instructionData, docInstructionData } from '~/utils/data'
import Card from './card'
import KycProgress from './KycProgress'
import { BottomSheetContainer } from './MuiComponents'
// import { LoadingButton } from '@mui/lab'
import KycButton from './styled/KycButton'
import { cancelNarration, speak, t } from '~/utils/narration'

export default function InitiateKyc({ onContinue, step = 0 }: any) {
  // const [completed, setCompleted] = useState<{ [k: number]: boolean }>({})
  // const [btnDisabled, setBtnDisabled] = useState(true)

  useEffect(() => {
    if (step) {
      speak({
        en: 'Now we will verify your I D document. Please keep it in a fixed place and ensure that the document is within the bounding box. We will capture a photo of the document.',
        hi: 'अब हम आपके पहचान डॉक्यूमेंट की पुष्टि करेंगे। कृपया इसे एक स्थिर जगह पर रखें और सुनिश्चित करें कि डॉक्यूमेंट बॉक्स के भीतर है। हम डॉक्यूमेंट की तस्वीर लेंगे।',
      })
    } else {
      speak({
        en: 'You are about to begin the K Y C process. Please ensure you are in a quiet room, alone, with good lighting and a stable internet connection. You should not be wearing any dark glasses or a mask. Keep your background clean, as we want to capture some clear photos of you.',
        hi: 'आप के वाई सी प्रक्रिया शुरू करने वाले हैं। कृपया सुनिश्चित करें कि आप एक शांत कमरे में अकेले हैं, अच्छी रोशनी और स्थिर इंटरनेट कनेक्शन के साथ। आप कोई काला चश्मा या मास्क न पहनें। अपना बैकग्राउंड साफ़ रखें, क्योंकि हम आपकी कुछ स्पष्ट तस्वीरें लेना चाहते हैं।',
      })
    }
    return () => cancelNarration()
  }, [])

  // useEffect(() => {
  //   // Set a timer to enable the button after 10 seconds
  //   const timer = setTimeout(() => {
  //     setBtnDisabled(false)
  //   }, 10000) // 10000ms = 10 seconds

  //   // Clean up the timer when the component is unmounted
  //   return () => clearTimeout(timer)
  // }, []) // Empty dependency array e

  return (
    <>
      <Typography variant="h3" fontWeight="bold" gutterBottom sx={{ mb: 4 }}>
        {step === 0
          ? t({ en: 'Get ready for KYC', hi: 'केवाईसी के लिए तैयार हो जाइए' })
          : t({ en: 'Continue with KYC process', hi: 'केवाईसी प्रक्रिया में आगे बढ़ें' })}
      </Typography>
      <KycProgress activeStep={step} />
      {/* <Stepper alternativeLabel activeStep={step} connector={<ColorlibConnector />}>
        {['Face Verification', 'Document Verification'].map((label, index) => (
          <Step key={label} completed={completed[index]}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>
              <Typography fontWeight="bold">{label}</Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper> */}

      <Box p="32px 8px 24px 8px">
        <Typography variant="h6" textAlign="left">
          {t({ en: 'Step', hi: 'स्टेप' })} {step + 1}
        </Typography>
        <Typography variant="h6" textAlign="left" fontWeight={600} gutterBottom>
          {step
            ? t({ en: 'Need to verify your ID document', hi: 'आपके पहचान डॉक्यूमेंट को वेरिफ़ाई करना है' })
            : t({ en: 'Capture your selfie photo', hi: 'अपनी सेल्फ़ी फ़ोटो लें' })}
        </Typography>

        <Typography variant="subtitle1" textAlign="left" gutterBottom>
          {t({
            en: 'Make sure the following conditions are met before starting the KYC process.',
            hi: 'केवाईसी प्रक्रिया शुरू करने से पहले सुनिश्चित करें कि निम्नलिखित सभी बातें पूरी हों।',
          })}
        </Typography>
      </Box>
      <Stack alignItems="stretch" flexDirection="column" flexWrap="wrap" justifyContent="center">
        {step === 1 ? (
          <>
            {docInstructionData.map((data) => (
              <Card key={data.img} {...data} />
            ))}
          </>
        ) : (
          <>
            {instructionData.map((data) => (
              <Card key={data.img} {...data} />
            ))}
          </>
        )}
      </Stack>
      <BottomSheetContainer maxWidth="sm">
        <Box sx={{}}>
          <Typography
            variant="h6"
            fontWeight={600}
            py={1}
            borderBottom="2px solid rgba(0,0,0,0.06)"
          >
            {step === 0
              ? t({ en: 'Proceed to start KYC process', hi: 'केवाईसी प्रक्रिया शुरू करने के लिए आगे बढ़ें' })
              : t({ en: 'Proceed to capture document photo', hi: 'डॉक्यूमेंट की फ़ोटो लेने के लिए आगे बढ़ें' })}
          </Typography>
        </Box>
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography
            variant="subtitle1"
            color="#222"
            gutterBottom
            sx={{ mb: 2, textAlign: 'start' }}
          >
            {t({
              en: "Checked all conditions? Let's proceed with the KYC process.",
              hi: 'क्या आपने सभी बातें जाँच ली हैं? अब केवाईसी प्रक्रिया में आगे बढ़ें।',
            })}
          </Typography>
          <KycButton step={step} onContinue={onContinue} />
        </Box>
      </BottomSheetContainer>
      {/* <Container maxWidth="sm" sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}>

      </Container> */}
    </>
  )
}
